import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DocumentActor } from 'src/app/models/actors';
import { StatusRequest } from 'src/app/models/requests';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { RequestStatusService } from '../requeststatus.service';
import { ActorStatusInformationModel } from 'src/app/models/api/actor-status-information.model';
import { RequestStatuses } from 'src/app/constants/status.enum';
import { PillBadgeStatusEnum } from 'src/app/constants/badge-status.enum';

@Component({
  selector: 'app-requeststatustitle',
  templateUrl: './requeststatustitle.component.html'
})
export class RequeststatustitleComponent implements OnDestroy {
  private requestSubscription!: Subscription;
  private actorListSubscription!: Subscription;
  hasEditRights: boolean = false;
  showMSplugins: boolean = false;
  actor!: DocumentActor;
  dossierPersonId!: string;
  RequestId!: string;
  user!: User;
  usersubscription: Subscription;
  statusIndicator!: string;
  timestamp!: string;
  translations: any = <any>{};
  requestType!: string;
  allowedToChangeOwnership: boolean = false;
  requestGuid!: string;
  request: StatusRequest = {} as StatusRequest;
  countOfTotalActions: number = 0;
  countOfTotalActionsDone: number = 0;
  statusBadge!: string;
  actors: ActorStatusInformationModel[] = [];

  constructor(private requestStatusService: RequestStatusService, private authenticationService: AuthenticationService, config: NgbProgressbarConfig, private toastService: ToastService, private translateService: TranslateService, private clipboardService: ClipboardService) {
    config.striped = false;
    config.animated = false;

    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      if (Object.keys(request).length === 0) return;
      this.request = request;
      this.requestGuid = request.id;
      this.allowedToChangeOwnership = this.requestStatusService.isUserAllowedToChangeOwnership();
      this.hasEditRights = this.requestStatusService.hasUserEditRights();
      this.showMSplugins = this.requestStatusService.showingMSPlugins();

      this.getStatusIndicator();
    });

    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  ngOnDestroy(): void {
    this.requestSubscription.unsubscribe();
  }

  private AllowedTitleLength: number = 42;
  displayAsTruncatedText(textToTruncate: string): boolean {
    if (textToTruncate && textToTruncate.length >= this.AllowedTitleLength) {
      return true;
    }
    return false;
  }
  truncateTo(textToTruncate: string) {
    if (textToTruncate && textToTruncate.length >= this.AllowedTitleLength) {
      return (textToTruncate.substring(0, this.AllowedTitleLength) + "....");
    }
    return textToTruncate
  }
  getTranslations() {
    this.translateService.get([
      'Toasts.ClipboardError',
      'Toasts.ClipboardNotSupported',
      'Toasts.Error'
    ]).subscribe(translation => {
      this.translations.toastsClipboardError = translation['Toasts.ClipboardError'];
      this.translations.toastsClipboardNotSupported = translation['Toasts.ClipboardNotSupported'];
      this.translations.error = translation['Toasts.Error'];
    });
  }

  async copyToClipboard() {
    try {
      if (!navigator.clipboard) {
        this.toastService.showError(this.translations.error, this.translations.toastsClipboardNotSupported);
      }
      await this.clipboardService.Copy(this.request.id);
      this.toastService.showCopied();
    }
    catch (error: any) {
      this.toastService.showError(this.translations.error, this.translations.toastsClipboardError);
    }
  }

  getStatusIndicator() {
    let primaryStatuses: string[] = RequestStatuses.PrimaryStatuses;
    let warningStatuses: string[] = RequestStatuses.WarningStatuses;
    let successStatuses: string[] = RequestStatuses.SuccessStatuses;
    let errorStatuses: string[] = RequestStatuses.ErrorStatuses;

    if (errorStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    }
    if (successStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    }

    if (primaryStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Primary;
    } else if (warningStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    } else if (successStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    } else if (errorStatuses.includes(this.request.status)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    } else {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    }

    if (this.statusIndicator === PillBadgeStatusEnum.Warning) {
      let countOfTotalActions = this.request.actors.length;
      let countOfTotalActionsDone = this.request.actors.filter((actor) => actor.signingDate).length;
      this.statusBadge = this.translateService.instant("Status.Sent") + " " + countOfTotalActionsDone + "/" + countOfTotalActions + "";
    } else if (this.statusIndicator === PillBadgeStatusEnum.Danger) {
      this.statusBadge = this.translateService.instant("Status." + this.request.status);
    } else {
      this.statusBadge = this.translateService.instant("Status.Completed");
    }
  }
}
